import React from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../../../../components/Dropdowns/SimpleDropdown';

const granularityOptions = [
  {
    value: 'daily',
    label: 'Daily',
  },
  {
    value: 'monthly',
    label: 'Monthly',
  },
];

const GranularityDropdown = ({ selected, disabled, onChange }) => (
  <SimpleDropdown
    selected={selected}
    options={granularityOptions}
    disabled={disabled}
    menuAlign="end"
    menuWidth={101}
    onChange={onChange}
  />
);

GranularityDropdown.propTypes = {
  selected: T.string.isRequired,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

export default GranularityDropdown;
